import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const ExecutionResultsLoading = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  label: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-log-events.logEventExecutionResultsTable.loadingResults"
  }),
  showLabel: true
});
export default ExecutionResultsLoading;